/**
* WYSIWYG four col JS
* -----------------------------------------------------------------------------
*
* All the JS for the WYSIWYG four col component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'wysiwyg-four-col',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'wysiwyg-four-col', COMPONENT );
} )( app );
